import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './ProfileTabs.module.scss';

export const ProfileTab = ({ label, to }) => {
  return (
    <div label={label} to={to} className={styles.tabContent}>
    </div>
  );
};

export const ProfileTabs = ({ children, basepath }) => {
  const location = useLocation();

  return (
    <div className={styles.tabs}>
      <ul className={styles.tabList}>
        {children.map((child) => {
          const to = `${basepath}${child.props.to}`;
          const isActive = location.pathname === to;
          return (
            <li key={child.props.label} className={isActive ? styles.active : ''}>
              <NavLink to={to}>
                {child.props.label}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};